<template>
  <div>
    <section-title
      content="Información de Contacto Primario"
      :has-line="true"
    />
    <div class="rounded pt-2 pb-3 px-4">
      <div class="row">
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoName"
            rules="required"
          >
            <label class="data-title mb-0">Nombre:</label>
            <custom-input
              v-model="model.nameFirst"
              :custom-error-msg="'El nombre es requerido.'"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <label class="data-title mb-0">Inicial:</label>
          <custom-input
            id="primaryContactInitialName"
            v-model="model.nameInitial"
            maxlength="1"
          />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoPaternalLastName"
            rules="required"
          >
            <label class="data-title mb-0">Apellido Paterno:</label>
            <custom-input
              v-model="model.nameLastPaternal"
              :custom-error-msg="'El apellido paterno es requerido.'"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <label class="data-title mb-0">Apellido Materno:</label>
          <custom-input v-model="model.nameLastMaternal" />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="providerMunicipality"
            rules="required"
          >
            <label class="data-title mb-0">Municipio de Residencia:</label>
            <custom-drop-down
              v-model="municipalitySelected"
              custom-error-msg="El municipio es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="municipalities"
              placeholder="Seleccione"
              @input="onChangeMunicipality"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <label class="data-title mb-0">Departamento:</label>
          <custom-input v-model="model.department" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <label class="data-title mb-0">Posición:</label>
          <custom-input v-model="model.position" />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors, failedRules }"
            name="primaryContactInfoEmail"
            rules="required|email"
          >
            <label class="data-title mb-0">Correo Electrónico:</label>
            <custom-input
              v-model="model.email"
              :custom-error-msg="
                failedRules['email']
                  ? 'El correo electrónico no es válido.'
                  : 'El correo electrónico es requerido.'
              "
              :error="errors[0]"
              type="email"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="cellPhone"
            v-slot="{ errors }"
            name="primaryContactInfoCellPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Celular:</label>
            <custom-input
              v-model="model.cellPhone"
              :custom-error-msg="'El teléfono celular es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            ref="workPhone"
            v-slot="{ errors }"
            name="workPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Trabajo:</label>
            <custom-input
              v-model="model.workPhone"
              :custom-error-msg="'El teléfono trabajo es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="fax"
            v-slot="{ errors }"
            name="primaryContactInfoFax"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Fax:</label>
            <custom-input
              v-model="model.fax"
              :custom-error-msg="'El fax es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="homePhone"
            v-slot="{ errors }"
            name="homePhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Hogar:</label>
            <custom-input
              v-model="model.homePhone"
              :custom-error-msg="'El teléfono del hogar es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'PrimaryContactInfo',
  components: {
    ValidationProvider,
    SectionTitle,
    CustomInput,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    municipalities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      municipalitySelected: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isSomePhoneFilledUp() {
      const cell = Boolean(this.model.cellPhone);
      const work = Boolean(this.model.workPhone);
      const fax = Boolean(this.model.fax);
      const home = Boolean(this.model.homePhone);
      return cell || work || fax || home;
    },
  },
  methods: {
    validateField() {
      if (!this.isSomePhoneFilledUp) {
        this.$refs['cellPhone'].reset();
        this.$refs['workPhone'].reset();
        this.$refs['fax'].reset();
        this.$refs['homePhone'].reset();
      }
    },
    onChangeMunicipality(item) {
      this.model.municipalityId = item?.id;
    },
  },
  watch: {
    'model.municipalityId': function(value) {
      if (this.municipalitySelected) return;
      if (!value) {
        this.municipalitySelected = null;
        return;
      }

      this.municipalitySelected = this.municipalities.find(
        (y) => y.id === value
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
